export const localStorageCheck = () => typeof localStorage !== 'undefined';
